import { CircleCheck } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from 'utils/formatMoney';
import {
  DisplayedTicketAddon,
  DisplayedTopUp,
} from '../ParticipantsInformation/ParticipantsInformation';

interface AddonsAndTopUpsSectionProps {
  addons: DisplayedTicketAddon[] | null;
  wallet_credit: DisplayedTopUp | null;
}

const AddonsAndTopUpsSection: React.FC<AddonsAndTopUpsSectionProps> = ({
  addons,
  wallet_credit: topUps,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      {addons && addons.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {addons.map(({ name, uses }) => (
            <div key={name} className="flex items-center gap-2">
              <CircleCheck size={16} />
              <p className="p2-medium">
                {uses > 0 ? `${uses} x` : null} {name}
              </p>
            </div>
          ))}
        </div>
      ) : null}
      {topUps && topUps.amount > 0 ? (
        <div>
          <p className="p1-medium">
            {t('orderConfirmationPage.topUpSubtitle')}{' '}
            {formatMoney(topUps.amount, topUps.currency)}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default AddonsAndTopUpsSection;
